import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCookies, setCookies } from '../redux/cookieHandler';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constants/cookieConstants';
import configs from '../configs/configs';

const { domains, prefix, apiVersions, serviceType } = configs.api || {};

const createBaseQuery = (serviceTypeKey) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: `${domains.main}${prefix}${serviceType[serviceTypeKey]}${apiVersions.version_one}`,
    prepareHeaders: async (headers) => {
      const token = await getCookies(ACCESS_TOKEN);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  });

  const baseQueryWithReAuth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === 401 || result?.error?.status === 403) {
      const refreshToken = await getCookies(REFRESH_TOKEN);
      if (refreshToken) {
        const refreshResult = await baseQuery(
          {
            url: `${domains.main}${prefix}${serviceType['user']}${apiVersions.version_one}/keep-alive`,
            method: 'GET'
          },
          api,
          extraOptions
        );

        if (refreshResult?.data) {
          const newAccessToken = refreshResult?.data?.accessToken;
          const newRefreshToken = refreshResult?.data?.refreshToken;
          setCookies(ACCESS_TOKEN, newAccessToken, { path: '/' });
          setCookies(REFRESH_TOKEN, newRefreshToken, { path: '/' });
          result = await baseQuery(args, api, extraOptions);
        }
      }
    }
    return result;
  };

  return baseQueryWithReAuth;
};

export default createBaseQuery;
